import { FETCH_DOWNLOADS_LIST } from "../actions/downloadsAction";

import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const downloadsReducer = (
    state = {
        downloadsList: null,
        downloadsListLoading: false,
        downloadsListError: null,
    },
    action,
) => {
    switch (action.type) {
        case isFulfilled(FETCH_DOWNLOADS_LIST):
            return { ...state, downloadsList: action.payload.data, downloadsListLoading: false, downloadsListError: null };
        case isPending(FETCH_DOWNLOADS_LIST):
            return { ...state, downloadsListLoading: true, downloadsListError: null };
        case isRejected(FETCH_DOWNLOADS_LIST):
            return { ...state, downloadsList: null, downloadsListLoading: false, downloadsListError: action.payload };
        default:
            return state;
    }
};

export default downloadsReducer;
